import Modal from "react-bootstrap/Modal";
import bin from "../assets/images/logout.svg";
import { useSelector } from "react-redux";

function OrganizationAlertModal(props) {
  const OrganizationList = useSelector(
    (state) => state?.userinfo?.Organizations
  );
  let Userdata = useSelector(
    (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
  );
  let currentOrganization = OrganizationList?.find(
    (f) => f.subscriberid === Userdata?.subscriberid
  );

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="delete-modal"
    >
      <Modal.Body>
        <div className="text-center">
          <img src={bin} alt="bin" className="modal-delete-icon" />
          <h5>
            Are you sure to upload machine in <br />{" "}
            {currentOrganization?.subscribername} (
            {currentOrganization?.companyname}) Organization ?
          </h5>
          <div className="d-flex align-items-center gap-2 mt-3">
            <button className="grey-btn" onClick={props.onHide}>
              No
            </button>
            <button
              className="red-btn"
              onClick={(e) => {
                props.onHide();
                props.handleSubmit(e);
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default OrganizationAlertModal;
